import { Type } from '@angular/core';
import {
  OtherFundDetailsDisplayComponent
} from '@products/other-details/other-fund-details-display-component.interface';
import { FundMangersComponent } from "@products/other-details/fund-mangers/fund-managers.component";
import { FundNavComponent } from "@products/other-details/fund-nav/fund-nav.component";
import { IDCWHistoryComponent } from "@products/other-details/idcw-history/idcw-history.component";
import { FundRisksComponent } from "@products/other-details/fund-risks/fund-risks.component";
import { FundDocumentsComponent } from "@products/other-details/fund-documents/fund-documents.component";

export class OtherFundDetailsComponentConfig {

  static readonly FUND_MANAGERS = new OtherFundDetailsComponentConfig(
    'Fund Managers',
    FundMangersComponent
  );

  static readonly DAILY_NAV = new OtherFundDetailsComponentConfig(
    'Daily Nav',
    FundNavComponent
  );

  static readonly IDCW_HISTORY = new OtherFundDetailsComponentConfig(
    'IDCW History',
    IDCWHistoryComponent,
  );
  static readonly FUND_RISKS = new OtherFundDetailsComponentConfig(
    'Fund Risks',
    FundRisksComponent,
  );
  static readonly FUND_DOCS = new OtherFundDetailsComponentConfig(
    'Fund Documents',
    FundDocumentsComponent,
  );

  static allConfigs: OtherFundDetailsComponentConfig[] = [
    OtherFundDetailsComponentConfig.FUND_MANAGERS,
    OtherFundDetailsComponentConfig.DAILY_NAV,
    OtherFundDetailsComponentConfig.IDCW_HISTORY,
    OtherFundDetailsComponentConfig.FUND_RISKS,
    OtherFundDetailsComponentConfig.FUND_DOCS,
  ];

  // returns matching config or undefined
  static getConfig(key: string): OtherFundDetailsComponentConfig {
    return this.allConfigs.find(
      (config: OtherFundDetailsComponentConfig): boolean => config.key === key
    );
  }

  private constructor(
    private readonly key: string,
    public readonly component: Type<OtherFundDetailsDisplayComponent>
  ) {
  }
}
